let PATH = document.location.origin
// PATH = 'http://127.0.0.1:8000'

export default PATH